const NON_BREAKING_SPACE = '\u00A0'

export function formatPoiPriceFromCents(cents: number, currency: string, locale: string): string {
    const resolvedCurrency = currency.toLowerCase() === 'eur' ? 'EUR' : 'CZK'
    const amount = cents / 100

    if (resolvedCurrency === 'CZK') {
        const formattedAmount = new Intl.NumberFormat('cs-CZ', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount)
        const currencyLabel = locale.toLowerCase().startsWith('cs') ? 'Kč' : 'CZK'

        return `${formattedAmount}${NON_BREAKING_SPACE}${currencyLabel}`
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: resolvedCurrency,
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    }).format(amount)
}
